import { CAMPAIGN_LOG_ENUM_TYPES } from '../../shared/constants'

const getAdditionalInfoForCampaignLogs = ({ type, additionalInfo = '' }) => {
  switch (type) {
    case CAMPAIGN_LOG_ENUM_TYPES.ARCHIVE_CAMPAIGN: {
      //internal status
      return `from ${additionalInfo}`
    }
    case CAMPAIGN_LOG_ENUM_TYPES.APPROVE_CAMPAIGN: {
      //with / without
      return `${additionalInfo} sending email`
    }
    case CAMPAIGN_LOG_ENUM_TYPES.DECLINE_CAMPAIGN: {
      //with / without
      return `${additionalInfo} sending email`
    }
    case CAMPAIGN_LOG_ENUM_TYPES.DELETE_CODES: {
      return `deleted ids ${additionalInfo}`
    }
    case CAMPAIGN_LOG_ENUM_TYPES.APPROVE_CODES: {
      //with / without
      return `${additionalInfo} sending email`
    }

    default: {
      return additionalInfo
    }
  }
}

export const getCampaignLogInsertedParams = logs => {
  return logs.map(log => {
    const { type, campaignId, additionalInfo } = log

    return {
      type,
      campaignId,
      additionalInfo: getAdditionalInfoForCampaignLogs({
        type,
        additionalInfo,
      }),
    }
  })
}

export const replaceNullValue = value => (value === null ? ' - ' : value)
